export default __webpack_public_path__ + "static/media/grands_ouvrages.bfabfedc.png";